export async function updateForm({ formDataKey, formDataValue, shouldValidate, setFieldValue }) {
    // Update the form field value only
    await setFieldValue(formDataKey, formDataValue, shouldValidate);
}
/**
 * Bulk‐update Formik with `setValues(...)` without updating URL queries.
 */
export async function updateFormBulk(values, shouldValidate = false, setValues) {
    // Update the form only
    await setValues(values, shouldValidate);
}
